export enum AnswerStatus {
    NotSelected = 1,
    Selected = 2,
    InCorrect = 3,
    Active = 4
}
